/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query AccountReadQuery($accountType: ACCOUNT_TYPE, $take: PositiveInt, $skip: Int, $search: String!, $filter: JSONObject) {
    AccountRead(accountType: $accountType, take: $take, skip: $skip, search: $search, filter: $filter) {
      id
      displayName,
      isActive,
      accountType,
      status,
      updatedAt,
      createdAt,
      email,
      isBlocked,
      is2FAEnabled,
      _totalCount
    }
  }`
